module.exports = __webpack_public_path__ + "static/media/animal-02.97018ab7.mp3";